/**
 *
 * 为兼容旧环境提供 Array.at() 方法的 polyfill
 */

// 检查是否支持 Array.at 方法
if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    // 将负索引转换为正索引
    const actualIndex = index < 0 ? this.length + index : index

    // 检查索引是否有效
    if (actualIndex < 0 || actualIndex >= this.length) {
      return undefined
    }

    return this[actualIndex]
  }
}

// 检查是否支持 String.at 方法
if (!String.prototype.at) {
  String.prototype.at = function (index) {
    // 将负索引转换为正索引
    const actualIndex = index < 0 ? this.length + index : index

    // 检查索引是否有效
    if (actualIndex < 0 || actualIndex >= this.length) {
      return undefined
    }

    return this[actualIndex]
  }
}

export default {}
